// extracted by mini-css-extract-plugin
module.exports = {"summary__header":"ReviewModalBasketSummary_summary__header__uVRAh","summary__details":"ReviewModalBasketSummary_summary__details__EuSDZ"};